import { render, staticRenderFns } from "./VlMeasures.vue?vue&type=template&id=7c4244f9&scoped=true&"
import script from "./VlMeasures.vue?vue&type=script&lang=js&"
export * from "./VlMeasures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4244f9",
  null
  
)

export default component.exports